"use client" 

// invoked from src/app/admin/jobs/page.js
// invoked from src/app/admin/layout.js
import { useEffect, useState, useRef } from "react";
import axios from "axios";

import { humanizeString, standardizeFileName } from "@/utils/frontend/stringOps.js";
import ModalOverlay from "../../Atoms/ModalOverlay.js";
import ModalHeader from "./ModalHeader.js";
import ModalFooter from "./ModalFooter.js";
import RadioButton from "../../Atoms/Buttons/RadioButton.js";
import FormSubHeading from "../../Atoms/FormElements/FormSubHeading.js";
import RadioButton_1 from "../../Atoms/Buttons/RadioButton_1.js";
import LocationSelect from "../../Atoms/Select/LocationSelect.js";
import { deleteTalnetBrowserCookies, getCookies } from "@/utils/frontend/cookieOps.js";
import InputText from "@/components/Atoms/inputText.js";
import TextEditor from "../TextEditor.js";
import TagsAssociationSelect from "@/components/Atoms/Select/TagsAssociationSelect.js";
import DatePicker from "@/components/Atoms/FormElements/DatePicker.js";
import SectorSelect from "@/components/Atoms/Select/SectorSelect.js";
import OrganizationSelect from "@/components/Atoms/Select/OrganizationSelect.js";
import validateRequiredFields from "@/utils/frontend/validateRequiredFields.js";
import { validateRequiredFieldsManually } from "@/utils/frontend/validateRequiredFieldsManually.js";
import MarkdownEditor from "../MarkdownEditor.js";
import JobPreviewCard from "../Cards/JobPreviewCard.js";
import ReactMarkdownMod from "@/components/Atoms/ReactMarkdownMod.js";
import DivisionSelect from "@/components/Atoms/Select/DivisionSelect.js";
import ReactMarkdownMod_2 from "@/components/Atoms/ReactMarkdownMod_2.js";
import LocationSelectGeoNames from "@/components/Atoms/Select/LocationSelectGeoNames.js";
import CurrencySelect from "@/components/Atoms/Select/CurrencySelect.js";
import BorderedFrameBox from "@/components/Molecules/BorderedFrameBox.js";
import FileUploadDragAndDrop from "@/components/Atoms/FileUploadDragAndDrop.js";
import { TealButton } from "@/components/Atoms/Buttons/ColorButtons.js";
import Link from "next/link.js";




const JobModal =  ({
  lang,
  state,
  callback,
  target,
  organizationPreferences,
  modalHeaderCaption,
  user
}) => {

  // console.log("TARGET@JOBMODAL", target)

  const textAreaRef1 = useRef(null);
  const textAreaRef2 = useRef(null);

  // const user = getCookies().user


// get current Primary and Secondary tag associations and set them as default values for 
let targetAssociatedLevel1Tags = [] // later set as State
let targetAssociatedLevel2Tags = [] // later set as State
let targetAssociatedLevel3Tags = [] // later set as State
if (target && target.tags) { 
  target.tags.filter(tag => {tag.tag_snapshot.tag_level === 1 ? targetAssociatedLevel1Tags.push(tag) : tag.tag_snapshot.tag_level === 2 ? targetAssociatedLevel2Tags.push(tag) : targetAssociatedLevel3Tags.push(tag)})
}

const blankDataInit = {
  id: 0,
  job_expiration_date: new Date().setUTCMonth(new Date().getUTCMonth() + 1),
  job_title_en: '',
  job_title_fr: '',
  job_description_en: '',
  job_description_fr: '',
  job_type: 'PERMANENT',
  job_salary: '',
  job_salary_currency: '',
  job_salary_period: 'YEAR',
  job_location: user?.user_location || '',
  // job_location_country: user?.user_location?.country || '',
  // job_location_state: user?.user_location?.state || '',
  // job_location_city: user?.user_location?.city || '',
  job_status: "PENDING_REVIEW",
  job_is_published: "PUBLISHED",
  job_employer_sector_industry: '',
  transaction_conditions_placement_fee_type: 'PERCENTAGE',
  transaction_conditions_placement_fee_job_owner_part: 50,
  transaction_conditions_placement_fee_candidate_owner_part: 50,
  transaction_conditions_placement_candidate_owner_payment_timing: 'WHEN_CANDIDATE_STARTS',
  transaction_conditions_guarantee_type: 'REPLACEMENT',
  transaction_conditions_guarantee_days_amount: 90,
}

const targetDataInit = {
  id: target?.id,
  job_title_en: target?.job_title.en,
  job_title_fr: target?.job_title.fr,
  job_description_en: target?.job_description.en,
  job_description_fr: target?.job_description.fr,
  job_type: target?.job_conditions?.job_type,
  job_salary: target?.job_conditions?.job_salary,
  job_salary_currency: target?.job_conditions?.job_salary_currency,
  job_salary_period: target?.job_conditions?.job_salary_period,
  job_location: target?.job_location,
  // job_location_country: target?.job_location.country || user?.user_location?.country,
  // job_location_state: target?.job_location.state || user?.user_location?.state,
  // job_location_city: target?.job_location.city || user?.user_location?.city,
  job_status: !target ? "PENDING_REVIEW" : target?.job_status,
  job_is_published: !target ? "PUBLISHED" : target?.job_is_published === true ? "PUBLISHED" : "UNPUBLISHED",
  job_employer_sector_industry: target?.job_employer_sector_industry,
  job_sector_industry: target?.job_sector_industry,
  job_expiration_date:  target?.job_expiration_date || new Date().setUTCMonth(new Date().getUTCMonth() + 1), // today + 1 month
  transaction_conditions_placement_fee_amount: target?.transaction_conditions?.placement_fee_amount,
  transaction_conditions_placement_fee_currency: target?.transaction_conditions?.placement_fee_currency,
  transaction_conditions_placement_fee_type: target?.transaction_conditions?.placement_fee_type,
  transaction_conditions_placement_fee_job_owner_part: target?.transaction_conditions?.placement_fee_job_owner_part,
  transaction_conditions_placement_fee_candidate_owner_part: target?.transaction_conditions?.placement_fee_candidate_owner_part,
  transaction_conditions_placement_candidate_owner_payment_timing: target?.transaction_conditions?.placement_candidate_owner_payment_timing,
  transaction_conditions_guarantee_days_amount: target?.transaction_conditions?.guarantee_days_amount,
  transaction_conditions_guarantee_type: target?.transaction_conditions?.guarantee_type,
}

let missingFieldsInit = {
  job_title_en: false,
  job_description_en: false,
  job_title_fr: false,
  job_description_fr: false,
  job_salary: false,
  job_location: false,
  // job_location_country: false,
  // job_location_state: false,
  // job_location_city: false,
  job_employer_sector_industry: false,
  job_sector_industry: false,
  transaction_conditions_placement_fee_amount: false,
  transaction_conditions_placement_fee_job_owner_part: false,
  transaction_conditions_placement_fee_candidate_owner_part: false,
  transaction_conditions_guarantee_days_amount: false,
}


const [loading, setLoading] = useState(false)
const [data, setData] = useState(blankDataInit) 
const [selectedTags, setSelectedTags] = useState()
const [selectedLevel1Tags, setSelectedLevel1Tags] = useState(targetAssociatedLevel1Tags)
const [selectedLevel2Tags, setSelectedLevel2Tags] = useState(targetAssociatedLevel2Tags)
const [selectedLevel3Tags, setSelectedLevel3Tags] = useState(targetAssociatedLevel3Tags)
const [tagsTable, setTagsTable] = useState(null)
const [missingFields, setMissingFields] = useState(missingFieldsInit)
const [previewOpen, setPreviewOpen] = useState(true)
const [fieldInFocus, setFieldInFocus] = useState(null)
const [langInFocus, setLangInFocus] = useState('en')
const [fileUploadDialogOpen, setFileUploadDialogOpen] = useState(false)
const [fileData, setFileData] = useState(null)
const [filePreview, setFilePreview] = useState(null)




useEffect(() => {

    // console.log("TARGET@useEffect", target)
    // console.log('targetDataInit@useEffect', targetDataInit)
    // setData({
    //   id: '',
    //   job_title_en: '',
    //   job_title_fr: '',
    //   job_description_en: '',
    //   job_description_fr: '',
    //   job_type: 'PERMANENT', // set defaults as you see fit
    //   job_salary: '',
    //   job_location: '',
    //   job_status: 'OPEN',
    //   job_is_published: 'PUBLISHED',
    //   job_employer_sector_industry: '',
    //   job_expiration_date: ''
    // });
  

    // setData(targetDataInit)
    
    // setSelectedPrimaryTags(targetAssociatedPrimaryTags)
    // setSelectedSecondaryTags(targetAssociatedSecondaryTags)


    if (target) {
      setData(targetDataInit)
      // set selected primary and secondary tags of a target to what's already associated. This is later updated in callback from handleTagsCallback. 
      setSelectedLevel1Tags(targetAssociatedLevel1Tags)
      setSelectedLevel2Tags(targetAssociatedLevel2Tags)
      setSelectedLevel3Tags(targetAssociatedLevel3Tags)
    }
    else {
      setData(blankDataInit)
      setSelectedLevel1Tags(targetAssociatedLevel1Tags)
      setSelectedLevel2Tags(targetAssociatedLevel2Tags)
      setSelectedLevel3Tags(targetAssociatedLevel3Tags)
    }



  // console.log("SELECTED PRIMARY", targetAssociatedPrimaryTags, "SELECTED SECONDARY", targetAssociatedSecondaryTags)

  const getTags = async () => {

    try {
      let apiUrl = `/api/tags/`;
      let response = await fetch(apiUrl, {
        method: `GET`,
        headers: {
          Accept: "*/*",
          "Content-Type": "application/json",
        },
        credentials: "include", // If you are sending cookies with a cross-origin request, use 'include'
      });

      response = await response.json();
      // console.log('getTags Response', response)

      setTagsTable(response.data);
    } catch (error) {
      console.log("error", error);
    }


  };

  getTags();

}, [target]);


const handleTagsCallback = cb => {
  console.log('Callback@HandleTagsCallback', cb)
  if (cb.lvlOne) {  // lvl1
    setSelectedLevel1Tags(cb.lvlOne.newTags)
  }
  if (cb.lvlTwo) { // lvl2
    setSelectedLevel2Tags(cb.lvlTwo.newTags)
  }
  if (cb.lvlThree) { // lvl3
    setSelectedLevel3Tags(cb.lvlThree.newTags)
  }
  console.log("SELECTED", selectedLevel1Tags, selectedLevel2Tags, selectedLevel3Tags)
}

  const handleDatePickerCallback = cb => {

    console.log('cbDatepicker', cb)
    if (cb.recreationOrExpiration === 'RECREATION') {
      setData({...data, job_recreated_date: cb.datePicker})
    }
    else if (cb.recreationOrExpiration === 'EXPIRATION') {
      setData({...data, job_expiration_date: cb.datePicker})
    }
  
  }

  const handleRadioButtonCallback = cb => {
    console.log('callback@JobModal', cb)
    if (cb.job_type) {setData({...data, job_type: cb.job_type})}
    if (cb.job_is_published) {setData({...data, job_is_published: cb.job_is_published})} // this is a str, not a Bool, it's converted to Bool in backend (post / put request)
    if (cb.job_status) {setData({...data, job_status: cb.job_status})}
    if (cb.job_salary_period) {
      setData({...data, job_salary_period: cb.job_salary_period})
    }

    if (cb.transaction_conditions_placement_fee_type) {
      setData({...data, transaction_conditions_placement_fee_type: cb.transaction_conditions_placement_fee_type})
    }

    if (cb.transaction_conditions_placement_candidate_owner_payment_timing){
      setData({...data, transaction_conditions_placement_candidate_owner_payment_timing: cb.transaction_conditions_placement_candidate_owner_payment_timing})
    }

    if (cb.transaction_conditions_guarantee_type){
      setData({...data, transaction_conditions_guarantee_type: cb.transaction_conditions_guarantee_type})
    }


    console.log(data)
    // callback({action: "presetFilterApplied", presetFilterQuery: cb})
  }

  const handleSectorSelectCallback = (field, cb) => {
    console.log("CB", cb)
     setData({ ...data, [field]: cb ? cb : null })
     console.log("XDATA", data)
  }

  


  const handleClose = async () => {
    state.setJobModalOpen(false)
    callback({resetTarget: true})
  }





  const handleFileUpload = (cb) => {

    if (cb.action === 'fileUpload') {
      setFileData({...fileData, file_name: standardizeFileName(cb.file.name), file_extension: cb.file.name.split('.')[1], file: cb.file})
      setFilePreview(URL.createObjectURL(cb.file))
    }

        if (cb === 'closeDialog' || cb === 'isDropped') {
      setFileUploadDialogOpen(false)
    }

    // if (cb === 'closeDialog' || cb === 'isDropped') {
    //   setFileUploadDialogOpen(false)
    // }
  }

  // const handleChange = (event) => {
  //   setData({
  //     ...data,
  //     [event.target?.name]: event.target?.value,
  //   });
  //   console.log(data);
  // };

  const handleChange = (event) => {

  if (
    event.target?.name === 'transaction_conditions_placement_fee_job_owner_part' ||
    event.target?.name === 'transaction_conditions_placement_fee_candidate_owner_part'
  ) {
    const { name, value } = event.target;
    const numericValue = Math.min(100, Math.max(0, Number(value)));

    if (name === 'transaction_conditions_placement_fee_job_owner_part') {
      setData(prev => ({
        ...prev,
        transaction_conditions_placement_fee_job_owner_part: numericValue,
        transaction_conditions_placement_fee_candidate_owner_part: 100 - numericValue
      }));
    }

    if (name === 'transaction_conditions_placement_fee_candidate_owner_part') {
      setData(prev => ({
        ...prev,
        transaction_conditions_placement_fee_candidate_owner_part: numericValue,
        transaction_conditions_placement_fee_job_owner_part: 100 - numericValue
      }));
    }
  }
    
    if (event.target?.name ==='job_salary' || event.target?.name === 'transaction_conditions_placement_fee_amount' || event.target?.name === 'transaction_conditions_placement_fee_candidate_owner_part' || event.target?.name === 'transaction_conditions_placement_fee_job_owner_part' || event.target?.name === 'transaction_conditions_guarantee_days_amount') {
      setData((prevData) => ({
        ...prevData,
        [event.target?.name]: event.target.value.replace(/\D/g, '')
      }));
      return;
    }

    setData((prevData) => ({
      ...prevData,
      [event.target?.name]: event.target?.value,
    }));
  
    if(event.target?.value.length > 1){setMissingFields((prevMissingFields) => ({
      ...prevMissingFields,
      [event.target?.name]: false, // Mark the field as not missing
    }));}
  };



  const handleSubmit = async () => {
    setLoading(true)

    console.log("Submitting data: ", data)


  // 1️⃣ Generate UUID for THIS record
  const recordUUID = crypto.randomUUID();

  // 2️⃣ Build the payload ONCE (source of truth)
  let recordPayload;
  if (target){ // if editing
    recordPayload = {
        ...data, // build as is
    };
  } else { // if new post or comment or reply
      recordPayload = {
        ...data,
        job_uuid:recordUUID,
    };
  }




  // ----------------------------
  // File upload (uses SAME UUID)
  // ----------------------------
  if (fileData?.file) {
    const formData = new FormData();
    formData.append("file", fileData.file, fileData.file_name);
    formData.append("file_name", fileData.file_name);
    formData.append("file_extension", fileData.file_extension);
    formData.append("user", JSON.stringify(user));
    // formData.append("record_data", JSON.stringify(recordPayload))

    let mediaUploadResponse = await fetch(
      `/api/services/files?user_type=${user.user_type}&file_type=DOCUMENT&parent_record_uuid=${target ? target.job_uuid : recordUUID}&record_type=JOB`,
      {
        method: "POST",
        credentials: "include",
        body: formData,
      }
    );

    console.log(mediaUploadResponse.status)


    if (mediaUploadResponse.status !== 200) {

      mediaUploadResponse.status === 401 && deleteTalnetBrowserCookies()

      console.log('ERROR: ', mediaUploadResponse)
      mediaUploadResponse = await mediaUploadResponse.json()
      state.setError({message: `Couldn't upload file. Error: ${mediaUploadResponse.error.message || mediaUploadResponse.error  }`})
      setLoading(false);
      return;
    }
  }




    // console.log("data@handleSubmit", data)

    // console.log("PRIMARY_TAGS@handleSubmit", selectedPrimaryTags)
    // console.log("SECONDARY_TAGS@handleSubmit", selectedSecondaryTags)
    // // setSelectedTags({PRIMARY: selectedPrimaryTags, SECONDARY: selectedSecondaryTags})
    // console.log("selectedTags@handleSubmit", selectedTags)


    // const tempMissingFields = validateRequiredFieldsManually(data, false, [...Object.keys(missingFieldsInit)])


    const tempMissingFields = validateRequiredFieldsManually(data, false, ['job_title_en', ...(user.user_languages?.working?.includes("FRENCH") ? ['job_title_fr'] : []), 'job_description_en', 'job_salary', 
    // 'job_location_country', 
    // 'job_location_state', 
    // 'job_location_city', 
    'job_location',
    'job_employer_sector_industry', 
    'job_sector_industry', 
    'transaction_conditions_placement_fee_amount', 
    'transaction_conditions_placement_fee_job_owner_part',
    'transaction_conditions_placement_fee_candidate_owner_part',
    'transaction_conditions_guarantee_days_amount',
    ])
    // const tempMissingFields = validateRequiredFieldsManually(data, false, [...Object.keys(missingFieldsInit)])

    setMissingFields(tempMissingFields)
  
  
    // Log missing fields after they've been updated
    console.log("MISSING FIELDS: ", tempMissingFields);
  
    // If there are any missing fields, do not proceed with form submission
    if (Object.values(tempMissingFields).includes(true)) {
      // Create a string listing the keys of missing fields
      const missingFieldsList = Object.keys(tempMissingFields)
      .filter(key => tempMissingFields[key] === true) // Filter for missing fields
      .join(', '); // Join them into a string

      state.setError({message: lang==='fr' ? `Champs obligatoires manquants: ${missingFieldsList}` : `Missing Required Fields: ${missingFieldsList}`})
      setLoading(false)
      return;
    }


        try {
        
          let jobApiUrl = target ? `/api/jobs/?id=${target.id}&user_type=${user.user_type}` : `/api/jobs/?user_type=${user.user_type}`
          let response = await fetch(jobApiUrl, {
          method: `${target ? 'PUT' : 'POST'}`, // Use uppercase for HTTP methods
          headers: {
            'Accept': '*/*',
            'Content-Type': 'application/json'
          },
          credentials: 'include', // If you are sending cookies with a cross-origin request, use 'include'
          body: JSON.stringify({data: recordPayload, tags: {LEVEL_1: selectedLevel1Tags, LEVEL_2: selectedLevel2Tags, LEVEL_3: selectedLevel3Tags}, user: user}), // Convert the credentials object to a JSON string
          // body: data
        });

        response = await response.json()
        console.log('handleSubmitResponse', response)

      if (response.success === true ) {
        state.setSuccess({message: lang === 'fr' ? "Le Poste a été publié." : 'Job listing created / updated.'})
        callback({refreshData: true})
        callback({resetTarget: true})
        setLoading(false)
        state.setJobModalOpen(false)
      }
      else { 
        state.setError({message: lang === 'fr' ? "Il y a eu un problème lors de la publication." : 'There was a problem creating / updating this job listing.'})
        setLoading(false)
      }
      callback({refreshData: true})

            
        } catch (error) {
          console.log('error', error)
          setLoading(false)
        }
  };


  return (
    <>

{/* <div class="right-0 top-0 overflow-x-hidden overflow-y-auto fixed inset-0 z-40 outline-none focus:outline-none mt-0 duration-300 ease-in-out transition-transform transform translate-x-full"> */}
<div
  className={`right-0 top-0 overflow-x-hidden fixed inset-0 z-40 outline-none focus:outline-none mt-0 duration-300 ease-in-out transition-transform transform ${
    state.jobModalOpen === true ? 'translate-x-0' : 'translate-x-full'
  }`}
>
<div className="lg:mb-0 px-4 w-full h-screen lg:sticky top-0 overflow-auto no-scrollbar lg:flex flex-col justify-center" key={target?.id}>
              {/* <div className="fixed top-0 right-0 h-screen w-full z-80 bg-white shadow-lg transform translate-x-full"> */}

              <div className={`mt-0 absolute duration-300 ease-in-out transition-transform transform ${previewOpen ? 'left-0 md:w-7/12' : 'right-0 md:w-7/12'} top-0 min-h-screen w-full`}>
                {/*content*/}
                <div className="border-0 min-h-screen shadow-none relative flex flex-col w-full bg-white outline-none focus:outline-none dark:bg-gray-900">
                  {/*header*/}
                  {/* <div className="flex items-start z-40 justify-between p-5 border-b border-solid border-slate-200 rounded-t"> */}

                  <ModalHeader caption={modalHeaderCaption} closeOnClickMethod={() => state.setJobModalOpen(false)}/>

   
{/* {console.log('data@jobModal', data)} */}

                  <div className="relative p-6 flex-auto text-left">
                    <div className="my-4 text-slate-500 text-lg leading-relaxed text-gray-900 dark:text-slate-200">

                    {/* <div className="col-span-5 w-6/12 mx-auto text-left"> */}
                    <div className="flex grid lg:grid-cols-12 gap-1 mt-2 mb-2 items-center">
                      {user.user_type === 'ROOT' && <div className={`lg:col-span-3 w-full`}>
                      <FormSubHeading data={lang === 'fr' ? "Date de Création du Poste" : 'Job Creation Date'}/>
                      <DatePicker callback={handleDatePickerCallback} recreationOrExpiration={'RECREATION'} targetDate={data.created_date || target?.created_date}/>
                        </div>}
                        <div className={`${user.user_type==='ROOT' ? 'lg:col-span-3' : 'lg:col-span-6'} w-full`}>
                      <FormSubHeading data={lang === 'fr' ? "Date d'Expiration du Poste" : 'Job Expiration Date'}/>
                      <DatePicker callback={handleDatePickerCallback} recreationOrExpiration={'EXPIRATION'} targetDate={data.job_expiration_date}/>
                        </div>   
                        <div className="lg:col-span-3 w-full justify-left">
                        <FormSubHeading data={lang === 'fr' ? "Type de Poste" : 'Job Type'}/>
                        <RadioButton_1
                          name="jobTypeRadioSwitch"
                          value1="PERMANENT"
                          value2="CONTRACT"
                          caption1="Permanent"
                          caption2={lang === 'fr' ? "Contrat" : "Contract"}
                          defaultChecked={data.job_type || 'PERMANENT'}
                          callback={handleRadioButtonCallback}
                          callbackObjectKey={'job_type'}
                        />
                  </div>

                      <div className="lg:col-span-3 w-full justify-left">
                        <FormSubHeading data={lang === 'fr' ? "Publication du Poste" : 'Job Publication'}/>
                        <RadioButton_1
                          name="jobIsPublishedRadioSwitch"
                          value1={"PUBLISHED"}
                          value2={"UNPUBLISHED"}
                          caption1={lang === 'fr' ? "Publié" : "Published"}
                          caption2={lang === 'fr' ? "Non Publié" : "Not Published"}
                          defaultChecked={data.job_is_published || "PUBLISHED"}
                          callback={handleRadioButtonCallback}
                          callbackObjectKey={'job_is_published'}
                        />
                  </div>

                  </div>


                  {/* <div className="flex grid lg:grid-cols-12 gap-1 mt-2 mb-2">
                      <div className="lg:col-span-6 w-full">
                      <FormSubHeading data={lang === 'fr' ? "Status du Poste" : 'Job Status'}/>
                      <RadioButton_1
                          name="jobStatusRadioSwitch"
                          value1="ACTIVE"
                          value2="INACTIVE"
                          caption1={lang === 'fr' ? "Ouvert" : "Active"}
                          caption2={lang === 'fr' ? "Fermé" : "Inactive"}
                          defaultChecked={data.job_status || 'ACTIVE'}
                          callback={handleRadioButtonCallback}
                          callbackObjectKey={'job_status'}
                        />
                        </div>       
                        <div className="lg:col-span-6 w-full justify-left">
                        <FormSubHeading data={lang === 'fr' ? "Publication du Poste" : 'Job Publication'}/>
                        <RadioButton_1
                          name="jobIsPublishedRadioSwitch"
                          value1={"PUBLISHED"}
                          value2={"UNPUBLISHED"}
                          caption1={lang === 'fr' ? "Publié" : "Published"}
                          caption2={lang === 'fr' ? "Non Publié" : "Not Published"}
                          defaultChecked={data.job_is_published || "PUBLISHED"}
                          callback={handleRadioButtonCallback}
                          callbackObjectKey={'job_is_published'}
                        />
                  </div>
                  </div> */}

              

                  
                {/* </div> */}

                      <div className="flex grid lg:grid-cols-6 gap-1 align-middle mb-2">
                      <div className={`${user.user_type === 'ROOT' ? 'lg:col-span-2' : user.user_languages?.working?.includes("FRENCH") ? 'lg:col-span-3' : 'lg:col-span-6'} w-full`}>
                      <InputText 
                        required={false} 
                        name='job_title_en' 
                        darkBGValue={'dark:bg-slate-900'}
                        onFocus={()=>setLangInFocus('en')}
                        data={{type: 'text', 

                          id:'job_title_en', value: data.job_title_en , onChange: handleChange, label: lang === 'fr' ? 'Titre du Poste en Anglais' : 'Job Title English'}} 
                        error={missingFields['job_title_en'] === true}
                      />
                        </div>       
                       {user.user_languages?.working?.includes("FRENCH") || user.user_type==='ROOT' && <div className={`${user.user_type === 'ROOT' ? 'lg:col-span-2' : 'lg:col-span-3'} w-full`}>
                        <InputText 
                        darkBGValue={'dark:bg-slate-900'}
                        onFocus={()=>setLangInFocus('fr')}
                        required={false} 
                        name='job_title_fr'
                        error={missingFields['job_title_fr'] === true}
                        data={{type: 'text', 
                          id:'job_title_fr', value: data.job_title_fr, onChange: handleChange, label: lang==='fr' ? 'Titre du Poste en Français' : 'Job Title French'}}/>
                      </div>}
                      {user.user_type === 'ROOT' &&
                      <div className="lg:col-span-2 w-full">
                        <OrganizationSelect
                          creatable={true}
                          placeholder="Select Associated Company..."
                          // value={
                          //   data.job_organization_name ? {label: data.job_organization_name, value: data.job_organization_id} || {label: target?.job_organization_name, value: target?.job_organization_id} : ''
                          // }
                          value={data.job_organization_name ? {label: data.job_organization_name, value: data.job_organization_id} : {label: target?.job_organization_name, value: target?.job_organization_id}}
                          onChange={(selected) => {
                            if (selected){
                              console.log('selected', selected)
                            setData({
                              ...data,
                              job_organization_name: selected.name,
                              job_organization_id: selected.id,
                              job_organization_uuid: selected.organization_uuid
                            });}
                            else {
                              setData({
                                ...data, 
                                job_organization_name: null,
                                job_organization_id: null,
                                job_organization_uuid: null
                              })
                            }
                          }}
                        />
                      </div>
                        }
   
                      </div>

                      <div className="flex grid lg:grid-cols-3 gap-1 mb-2">
                      <div className="lg:col-span-1 w-full">
                        <FormSubHeading data={lang === 'fr' ? "Secteur de l'Employeur" : "Employer Sector"}/>
                      <SectorSelect
                      isMulti={false}
                      missingRequired={missingFields['job_employer_sector_industry'] === true ? true : false}
                      parentField={'job_employer_sector_industry'}
                      onChange={()=>{}}
                      lang={lang}
                      callback={(x)=>handleSectorSelectCallback('job_employer_sector_industry', x)}
                        target={target}
                        // onChange={(selection) => { setData({ ...data, job_employer_sector_industry: selection ? selection : null });}}
                        placeholder={lang === 'fr' ? "Secteur de l'Employeur" : 'Employer Sector'}
                      />
                      </div>
                      <div className="lg:col-span-1 w-full">
                      <FormSubHeading data={lang === 'fr' ? "Secteur de l'Emploi" : "Job Sector"}/>
                    <DivisionSelect
                      missingRequired={missingFields['job_sector_industry'] === true ? true : false}
                      parentField={'job_sector_industry'}
                      onChange={()=>{}}
                      lang={lang}
                      callback={(x)=>handleSectorSelectCallback('job_sector_industry', x)}
                        target={target}
                        placeholder={lang === 'fr' ? "Secteur de l'Emploi" : 'Job Sector'}
                      />
                      </div>

                      {/* level 1 tag */}
                      <div className="lg:col-span-1 w-full">
                      <FormSubHeading data={lang === 'fr' ? "Sous-Secteur de l'Emploi" : "Job SubSector"}/> 
                      <TagsAssociationSelect lang={lang} state={{error: state.error, setError: state.setError}} selectedParent={data.job_sector_industry?.id} isMulti={false} tagsTable={tagsTable} callback={handleTagsCallback} tagsLevel={1} target={target} placeholder={lang === 'fr' ? "Sous-Secteur" : "SubSector"}/>
                      </div>
                      </div>
                      <div className="flex grid lg:grid-cols-2 gap-1 mb-2">
                      {/* level 2 tag */}
                      <div className="lg:col-span-1 w-full">
                      <FormSubHeading data={lang === 'fr' ? "Tags Principaux" : "Primary Tags"}/>
                      <TagsAssociationSelect lang={lang} state={{error: state.error, setError: state.setError}} selectedParent={data.job_sector_industry?.id} tagsTable={tagsTable} callback={handleTagsCallback} tagsLevel={2} target={target} placeholder={lang === 'fr' ? "Tags Principaux" : "Primary Tags"}/>
                      </div>
                      {/* level 3 tag */}
                      <div className="lg:col-span-1 w-full">
                      <FormSubHeading data={lang === 'fr' ? "Tags Secondaires" : "Secondary Tags"}/>
                      <TagsAssociationSelect lang={lang} state={{error: state.error, setError: state.setError}} selectedParent={data.job_sector_industry?.id} tagsTable={tagsTable} callback={handleTagsCallback} tagsLevel={3} target={target} placeholder={lang === 'fr' ? "Tags Secondaires" : "Secondary Tags"}/>
                      </div>

                      </div>
                      {/* <DatePicker callback={handleDatePickerCallback} targetDate={target?.job_expiration_date}/> */}



<div className="flex grid lg:grid-cols-3 gap-1 align-middle mb-2">
                      <div className="lg:col-span-3 w-full">
<LocationSelectGeoNames
  missingRequired={missingFields['job_location'] === true ? true : false}
  name="job_location"
  id="job_location"
  placeholder="Start typing in the city name..."
  value={
    data.job_location
      ? {
          value: data.job_location.value,
          label: data.job_location.label
        }
      : null
  }
  // value= { newUserData.user_location || null}
  onChange={(selection) => {
    console.log("SELECTION", selection)
    setData({
      ...data,
      job_location: selection
    });
    selection?.value ? setMissingFields({...missingFields, job_location: false }) : setMissingFields({...missingFields, job_location: true })
  }}
/>
</div>
</div>


{/* OLD LOCATIONS */}
{/* <div className="flex grid lg:grid-cols-3 gap-1 align-middle mb-2">
                      <div className="lg:col-span-1 w-full">

              <LocationSelect
              missingRequired={missingFields['job_location_country'] === true }
              zoomLevel={'COUNTRIES'}
              value = {data.job_location_country ? {value: data.job_location_country, label: humanizeString(data.job_location_country)} : user.user_location?.country ? {value: user.user_location.country, label: humanizeString(user.user_location.country)}: ''} 
              placeholder={lang === 'fr' ? 'Pays' : 'Country'}
              onChange={(selection) => {
              setData({ ...data, job_location_country: selection ? selection.value : null });
              selection.value && setMissingFields({...missingFields, job_location_country: false });
              }}
            />
</div>

<div className="lg:col-span-1 w-full">
                         
            <LocationSelect
            missingRequired={missingFields['job_location_state'] === true ? true : false }
              zoomLevel={'STATES'}
            isDisabled={!data.job_location_country && !user.user_location.country}
            selectedCountry={data?.job_location_country || user?.user_location?.country}
            value = {data.job_location_state ? {value: data.job_location_state, label: humanizeString(data.job_location_state)} : ''}
            placeholder={lang === 'fr' ? 'Province / État' : "State or Province"}
            onChange={(selection) => {
              setData({ ...data, job_location_state: selection ? selection.value : null, job_location_city: null });
              selection.value && setMissingFields({...missingFields, job_location_state: false });
                            }}
                          />
            </div>

            <div className="lg:col-span-1 w-full">
                         
            <LocationSelect
            missingRequired={missingFields['job_location_city'] === true ? true : false }
            isDisabled={!data.job_location_state && !user.user_location.state}
            zoomLevel={'CITIES'}
            selectedCountry={data?.job_location_country || user?.user_location?.country}
            selectedState={data?.job_location_state || user?.user_location?.state}
            value = {data.job_location_city ? {value: data.job_location_city, label: humanizeString(data.job_location_city)} : ''}
            placeholder={lang === 'fr' ? 'Ville' : "City"}
            onChange={(selection) => {
              setData({ ...data, job_location_city: selection ? selection.value : null });
              selection.value && setMissingFields({...missingFields, job_location_city: false });
            }}
                          />
            </div>
<div className="lg:col-span-1 w-full">


                      </div>
                      
                      </div> */}

                 
<div className="flex grid lg:grid-cols-12 gap-1 align-middle mb-2">
  <div className="lg:col-span-4 w-full mt-1">
    <InputText 
      error={missingFields['job_salary'] === true}
      darkBGValue={'dark:bg-slate-900'}
      name='job_salary' data={{type: 'text', id:'job_salary', value: data.job_salary || '', onChange: handleChange, label: lang === 'fr' ? 'Salaire Offert' : 'Offered Salary'}}
    />
    </div>


    <div className="lg:col-span-4 w-full mt-1 flex items-center">
  
  <CurrencySelect 
  defaultValue={{"id": 1, "label": "USD", "value": "USD"}}
  userCountryCode = {user?.user_location?.country_code}
  placeholder={'Currency'}
  target={target?.job_conditions} 
  parentField={'job_salary_currency'} 
  onChange={()=>{}} 
  lang={'en'} 
  callback={cb=>{setData({...data, job_salary_currency: cb})}}
  // callback={(x)=>{console.log(x); 
  //   setTagData({...tagData, topic_sector_industry: x})
  // }}
  />
              </div>


              <div className="lg:col-span-4 w-full mt-1 flex items-center">
                          <RadioButton_1
                          name="jobSalaryPeriodRadioSwitch"
                          value1={"YEAR"}
                          value2={"MONTH"}
                          value3={"HOUR"}
                          caption1="Per Year"
                          caption2="Per Month"
                          caption3="Per Hour"
                          defaultChecked={target ? data.job_salary_period : "YEAR"}
                          callback={handleRadioButtonCallback}
                          callbackObjectKey={'job_salary_period'}
                        />

              </div>

</div>









   {     
               user?.user_roles.role === 'ROOT' && 
               <div className="mt-2 flex gap-2 text-xs text-slate-500 dark:text-slate-400">
               <div className="flex gap-1 items-center rounded-2xl">
                    


             <select
              id="status_change"
              name="status_change"
              className="py-4 px-4 rounded-lg bg-slate-100 dark:bg-slate-800"
              value={data.job_status || ''}
              onChange={(e) => {
                setData({
                  ...data,
                  job_status: e.target.value
                });
              }}
            >
              <option value="" disabled>
                Status: {humanizeString(data.job_status)}
              </option>

              <option value="PENDING_REVIEW">PENDING_REVIEW</option>
              <option value="ACTIVE">ACTIVE</option>
              <option value="INACTIVE">INACTIVE</option>
              <option value="FLAGGED">FLAGGED</option>
              <option value="REJECTED">REJECTED</option>
              <option value="ARCHIVED">ARCHIVED</option>
            </select>       

               {/* <select id="status_change" name="status_change" className="py-4 px-4 rounded-lg bg-slate-100 dark:bg-slate-800" defaultValue={''}>
               <option value="" disabled> Status: {humanizeString(data.job_status)}</option>    
               <option onClick={(e)=>{setData({...data, job_status: 'PENDING_REVIEW'})}} value="PENDING_REVIEW">PENDING_REVIEW</option>
               <option onClick={(e)=>{setData({...data, job_status:'ACTIVE'})}} value="ACTIVE">ACTIVE</option>
              <option onClick={(e)=>{setData({...data, job_status:'INACTIVE'})}} value="INACTIVE">INACTIVE</option>
               <option onClick={(e)=>{setData({...data, job_status:'FLAGGED'})}} value="FLAGGED">FLAGGED</option>
               <option onClick={(e)=>{setData({...data, job_status:'REJECTED'})}} value="REJECTED">REJECTED</option>
               <option onClick={(e)=>{setData({...data, job_status:'ARCHIVED'})}} value="ARCHIVED">ARCHIVED</option>

               </select> */}
               </div>
               </div>
          }


{/* job verification */}
              <div className="grid lg:grid-cols-3 gap-4 mt-8">
                  <div className={`lg:col-span-2 flex justify-center items-end flex-col`}>
  <div className="text-base">Verify this job for added trust (it's free)</div>
                    <div className="text-xs text-right">
                      {/* Attach your signed client agreement to verify this role and receive a verified checkmark - increasing trust and attracting serious recruiter submissions.<br/> */}
                      <Link target="_blank" className="text-teal-400 hover:underline" href="https://talnet.co/space/docs/#job-verification">
                      <i className="fa-solid fa-circle-info"></i>
                      How it works
                      </Link>
                    </div>

                </div>
             <div className={`lg:col-span-1`}>

              {fileUploadDialogOpen === true ? 
                <FileUploadDragAndDrop 
              acceptedFileTypes={'documents'} 
              // isCloseable={false} 
              paddingY={'sm'} lang={'en'} fileName={fileData?.file_name || ''} 
              // callback={(cb)=>{cb === 'closeDialog' && setFileUploadDialogOpen(false)}}
              callback={handleFileUpload}
              />
              :
              <TealButton buttonSize={1} caption={fileData?.file_name ? fileData?.file_name?.substring(0, 20)+'...'+fileData?.file_extension : 'Submit for verification'} onClick={()=>{setFileUploadDialogOpen(true)}}/>
             }
            </div>

</div>






<div className="mt-8">

            <BorderedFrameBox 
              borderColor="border-teal-400"
              title={'Transaction conditions'} 
              body={ <>
                <div>
                  <div className="grid lg:grid-cols-3 gap-4">

                  {/* fee structure */}
                  <div className="lg:col-span-1 flex justify-center items-end flex-col">
                    <div className="text-base">Fee Structure (% or $)</div>
                    <div className="text-sm">This is the fee agreed upon with your client</div>
                  </div>
                  <div className="lg:col-span-1">
                            <InputText 
                        required={false} 
                        name='transaction_conditions_placement_fee_amount' 
                        darkBGValue={'dark:bg-slate-950'}
                        data={{type: 'text', 
                          id:'transaction_conditions_placement_fee_amount', value: data.transaction_conditions_placement_fee_amount , onChange: handleChange, label: `${data.transaction_conditions_placement_fee_type === 'FLAT' ? 'Placement Fee ($)' : 'Placement Fee (%)'}`}} 
                        error={missingFields['transaction_conditions_placement_fee_amount'] === true}
                      />
                  </div>
                  <div className="lg:col-span-1 flex items-center gap-1">
                    <RadioButton_1
                          name="transaction_conditions_placement_fee_type"
                          value1={"PERCENTAGE"}
                          value2={"FLAT"}
                          caption1="%"
                          caption2="$"
                          defaultChecked={target ? data.transaction_conditions_placement_fee_type : "PERCENTAGE"}
                          callback={handleRadioButtonCallback}
                          callbackObjectKey={'transaction_conditions_placement_fee_type'}
                        />
                    {/* {console.log("TARGET", target?.transaction_conditions)} */}
                      {data.transaction_conditions_placement_fee_type === 'FLAT' && <CurrencySelect 
                        defaultValue={{"id": 1, "label": "USD", "value": "USD"}}
                        userCountryCode = {user?.user_location?.country_code}
                        placeholder={'Currency'}
                        target={target?.transaction_conditions} 
                        // parentField={'job_salary_currency'} 
                        // parentField={'transaction_conditions_placement_fee_currency'}
                        parentField={'placement_fee_currency'}
                        onChange={()=>{}} 
                        lang={'en'} 
                        callback={cb=>{setData({...data, transaction_conditions_placement_fee_currency: cb})}}
                        // callback={(x)=>{console.log(x); 
                        //   setTagData({...tagData, topic_sector_industry: x})
                        // }}
                      />}
                  </div>



                  {/* split structure */}
                  <div className="lg:col-span-1 flex justify-center items-end flex-col">
                    <div className="text-base">Split Structure (%)</div>
                    <div className="text-sm">This is your desired split with the candidate owner</div>
                  </div>
                  <div className="lg:col-span-1">
                            <InputText 
                        required={false} 
                        name='transaction_conditions_placement_fee_job_owner_part' 
                        darkBGValue={'dark:bg-slate-950'}
                        // onFocus={()=>setLangInFocus('en')}
                        data={{type: 'text', 
                          id:'transaction_conditions_placement_fee_job_owner_part', value: data.transaction_conditions_placement_fee_job_owner_part , onChange: handleChange, label: "Job Owner's (your) part (%)"}} 
                        error={missingFields['transaction_conditions_placement_fee_job_owner_part'] === true}
                      />
                  </div>
                  <div className="lg:col-span-1">
                        <InputText 
                        required={false} 
                        name='transaction_conditions_placement_fee_candidate_owner_part' 
                        darkBGValue={'dark:bg-slate-950'}
                        // onFocus={()=>setLangInFocus('en')}
                        data={{type: 'text', 
                          id:'transaction_conditions_placement_fee_candidate_owner_part', value: data.transaction_conditions_placement_fee_candidate_owner_part , onChange: handleChange, label: "Candidate Owner's Part (%)"}} 
                        error={missingFields['transaction_conditions_placement_fee_candidate_owner_part'] === true}
                      />
                  </div>


                  {/* payment terms */}
                 <div className="lg:col-span-1 flex justify-center items-end flex-col">
                    <div className="text-base">Payment terms</div>
                    <div className="text-sm">When does the candidate owner get paid?</div>
                  </div>
                  <div className="lg:col-span-2">
                    <RadioButton_1
                          name="transaction_conditions_placement_candidate_owner_payment_timing"
                          value1={"WHEN_CANDIDATE_STARTS"}
                          value2={"WHEN_CLIENT_PAYS"}
                          caption1="Upon Candidate Start Date"
                          caption2="Upon Client Payment"
                          defaultChecked={target ? data.transaction_conditions_placement_candidate_owner_payment_timing : "WHEN_CANDIDATE_STARTS"}
                          callback={handleRadioButtonCallback}
                          callbackObjectKey={'transaction_conditions_placement_candidate_owner_payment_timing'}
                        />
                  </div>


                  {/* guarantee terms */}
                  <div className="lg:col-span-1 flex justify-center items-end flex-col">
                    <div className="text-base">Guarantee Terms</div>
                    <div className="text-sm">This is the guarantee agreed upon with your client</div>
                  </div>
                  <div className="lg:col-span-1">
                            <InputText 
                        required={false} 
                        name='transaction_conditions_guarantee_days_amount' 
                        darkBGValue={'dark:bg-slate-950'}
                        data={{type: 'text', 
                          id:'transaction_conditions_guarantee_days_amount', value: data.transaction_conditions_guarantee_days_amount , onChange: handleChange, label: 'Guarantee Length (days)'}} 
                        error={missingFields['transaction_conditions_guarantee_days_amount'] === true}
                      />
                  </div>
                  <div className="lg:col-span-1 flex items-center gap-1">
                    <RadioButton_1
                          name="transaction_conditions_guarantee_type"
                          value1={"REPLACEMENT"}
                          value2={"REFUND"}
                          caption1="Replacement"
                          caption2="Refund"
                          defaultChecked={target ? data.transaction_conditions_guarantee_type : "REPLACEMENT"}
                          callback={handleRadioButtonCallback}
                          callbackObjectKey={'transaction_conditions_guarantee_type'}
                        />
                  </div>




                 </div>
                </div>
              
              </>}
            />
</div>



            <FormSubHeading data={lang==='fr' ? 'Descriptif en Anglais' : 'Job Description in English'}/>
            <MarkdownEditor 
            textAreaRows={25}
              textAreaOnChange={(x)=>{setFieldInFocus(x.target?.name)}} 
              textAreaName={'job_description_en'}
              textAreaId={'job_description_en'}
              callback={(x)=>{handleChange(x)}} 
              showPreview={false} 
              textAreaRef={textAreaRef1} 
              textAreaValue={data.job_description_en} 
              textAreaPlaceholder={lang === 'fr' ? "Descriptif en Anglais" : 'Job Description'}
            />

            {user.user_languages?.working?.includes('FRENCH') && <MarkdownEditor 
            textAreaRows={25}
            textAreaOnChange={(x)=>{setFieldInFocus(x.target?.name)}} 
            textAreaName={'job_description_fr'}
            textAreaId={'job_description_fr'}
            callback={(x)=>{handleChange(x)}} 
            showPreview={false} 
            // textAreaOnChange={handleChange} 
            textAreaRef={textAreaRef2} 
            textAreaValue={data.job_description_fr} 
            textAreaPlaceholder={lang === 'fr' ? "Descriptif en Français" : 'Description in French'}
            />}




                    </div>
            
                  </div>

                  



   
              

                  {/*footer*/}
                  {/* <ModalFooter missingRequiredFields={false} loading={loading} cancelButtonCaption={lang==='fr' ? 'Annuler' : 'Cancel'} submitButtonCaption1={lang==='fr' ? <>{target ? <><i className="fa-solid fa-floppy-disk mr-1"/>Sauvegarder</> : <><i className="fa-solid fa-rocket mr-1"></i>Afficher</>}</> : <>{target ? <><i className="fa-solid fa-floppy-disk mr-1"/>Save</> : <><i className="fa-solid fa-rocket mr-1"></i>Post</>}</>} closeOnClickMethod={() => state.setJobModalOpen(false)} saveOnClickMethod1={handleSubmit} 
                  state={{error: state.error, setError: state.setError, success:state.success, setSuccess: state.setSuccess}}
                  /> */}

<ModalFooter 
                  missingRequiredFields={missingFields} 
                  loading={loading} 
                  cancelButtonCaption={lang==='fr' ? 'Annuler' : 'Cancel'} 
                  submitButtonCaption1={lang==='fr' ? <>{target ? <><i className="fa-solid fa-floppy-disk mr-1"/>Sauvegarder</> : <><i className="fa-solid fa-rocket mr-1"></i>Afficher</>}</> : <>{target ? <><i className="fa-solid fa-floppy-disk mr-1"/>Save</> : <><i className="fa-solid fa-rocket mr-1"></i>Post</>}</>} 

                  submitButtonCaption2={lang === 'fr' ? !previewOpen ? <><i className="fa-solid fa-eye mr-1"/>Ouvrir Aperçu</> : <><i className="fa-solid fa-eye-slash mr-1"/>Fermer Aperçu</> : previewOpen ? <><i className="fa-solid fa-eye-slash mr-1"/>Close Preview</> : <><i className="fa-solid fa-eye mr-1"/>Open Preview</>}
                  saveOnClickMethod1={()=>{handleSubmit()}} 
                  saveOnClickMethod2={()=>{setPreviewOpen(!previewOpen)}}
                  closeOnClickMethod={() => {handleClose()}} 
                  state={{error: state.error, setError: state.setError, success:state.success, setSuccess: state.setSuccess}}
                  />

                </div>
              </div>
            </div>

            <div key={target?.id+1}>
              {/* <div className="fixed top-0 right-0 h-screen w-full z-80 bg-white shadow-lg transform translate-x-full"> */}

              <div className={`fixed right-0 top-0 min-h-screen w-5/12 duration-300 ease-in-out transition-transform transform invisible md:visible ${
    previewOpen === true ? 'translate-x-0' : 'translate-x-full'
  }`}>
                {/*content*/}
                <div className="border-0 min-h-screen shadow-none relative flex flex-col w-full outline-none focus:outline-none bg-slate-50 dark:bg-slate-800">
                  {/*header*/}
                  {/* <div className="flex items-start z-40 justify-between p-5 border-b border-solid border-slate-200 rounded-t"> */}
                  
                  <ModalHeader caption={lang === 'fr' ? <><i className="fa-solid fa-binoculars mr-2"/>Aperçu</> : <><i className="fa-solid fa-binoculars mr-2"/>Preview</>} closeOnClickMethod={() => setPreviewOpen(false)}/>
                  {/* <div className="fixed top-0 bg-inherit flex items-center z-50 px-2 py-1 h-screen">
                    test
                  </div> */}
                  <br/>
                  <div className="px-8">
                  {data && 
                  <JobPreviewCard
                            lang={langInFocus}
                            data={{...data, job_location: data.job_location}}
                            // tags={[selectedLevel1Tags].concat(selectedLevel2Tags, selectedLevel3Tags)}
                            tags={Array.isArray(selectedLevel1Tags) ? selectedLevel1Tags.concat(selectedLevel2Tags, selectedLevel3Tags) : [selectedLevel1Tags].concat(selectedLevel2Tags, selectedLevel3Tags)}

                          />
                          }
                  </div>
                  {/* col-span-1 border rounded-lg p-4 prose prose-sm max-w-none h-96 overflow-y-auto bg-white text-slate-700 whitespace-pre-wrap */}

                  {data[`job_description_${lang || 'en'}`] && <div className={`mx-8 px-6 py-8 my-10 rounded-xl bg-white dark:bg-gray-900 shadow-lg flex-col h-full text-slate-500 dark:text-slate-300 font-inter overflow-auto max-w-none prose prose-lg dark:prose-invert break-word`}>

                  {/* <ReactMarkdownMod_2 args={data[fieldInFocus || `job_description_${lang || 'en'}`]}/> */}
                                <ReactMarkdownMod_2>
                                  {data[fieldInFocus || `job_description_${lang || 'en'}`]}
                                  </ReactMarkdownMod_2>

                    </div>}
   
   
                  {/* <div className="relative p-6 flex-auto text-left">
                    <div className="my-4 text-slate-500 text-lg leading-relaxed text-gray-900 dark:text-slate-200">
                    </div>
                  </div> */}
                      
                      
                      </div>
                      </div></div>


          </div>

          {state.jobModalOpen && <ModalOverlay/>}
        </>

  );
};

export default JobModal;































// "use client" 

// // invoked from src/app/admin/jobs/page.js
// // invoked from src/app/admin/layout.js
// import { useEffect, useState, useRef, use } from "react";
// import axios from "axios";

// import { humanizeString } from "@/utils/frontend/stringOps.js";
// import ModalOverlay from "../../Atoms/ModalOverlay.js";
// import ModalHeader from "./ModalHeader.js";
// import ModalFooter from "./ModalFooter.js";
// import RadioButton from "../../Atoms/Buttons/RadioButton.js";
// import FormSubHeading from "../../Atoms/FormElements/FormSubHeading.js";
// import RadioButton_1 from "../../Atoms/Buttons/RadioButton_1.js";
// import LocationSelect from "../../Atoms/Select/LocationSelect.js";
// import { getCookies } from "@/utils/frontend/cookieOps.js";
// import InputText from "@/components/Atoms/inputText.js";
// import TextEditor from "../TextEditor.js";
// import TagsAssociationSelect from "@/components/Atoms/Select/TagsAssociationSelect.js";
// import DatePicker from "@/components/Atoms/FormElements/DatePicker.js";
// import SectorSelect from "@/components/Atoms/Select/SectorSelect.js";
// import OrganizationSelect from "@/components/Atoms/Select/OrganizationSelect.js";
// import { validateRequiredFieldsManually } from "@/utils/frontend/validateRequiredFieldsManually.js";
// import MarkdownEditor from "../MarkdownEditor.js";
// import ReactMarkdown from 'react-markdown';
// import JobPreviewCard from "../Cards/JobPreviewCard.js";
// import ReactMarkdownMod from "@/components/Atoms/ReactMarkdownMod.js";



// const JobModal =  ({
//   lang,
//   state,
//   callback,
//   target,
//   organizationPreferences,
//   modalHeaderCaption
// }) => {

//   const textAreaRef1 = useRef(null);
//   const textAreaRef2 = useRef(null);

//   // console.log('TRGT@JOBModal', target)
//   const user = getCookies().user


//   // console.log("TARGET@JobModal", target)

// // get current Primary and Secondary tag associations and set them as default values for 
// let targetAssociatedLevel1Tags = [] // later set as State
// let targetAssociatedLevel2Tags = [] // later set as State
// if (target && target.tags) { 
//   target.tags.filter(tag => {tag.tag_level === 1 ? targetAssociatedLevel1Tags.push(tag) : targetAssociatedLevel2Tags.push(tag)})
// }


// const blankDataInit = {
//   id: 0,
//   job_expiration_date: new Date().setUTCMonth(new Date().getUTCMonth() + 1),
//   job_title_en: '',
//   job_title_fr: '',
//   job_description_en: '',
//   job_description_fr: '',
//   job_type: 'PERMANENT',
//   job_salary: '',
//   job_location_country: user?.user_location.country || '',
//   job_location_state: user?.user_location.state || '',
//   job_location_city: user?.user_location.city || '',
//   job_status: "OPEN",
//   job_is_published: "PUBLISHED",
//   job_sector_industry: ''
// }


// const targetDataInit = {
//   id: target?.id,
//   job_title_en: target?.job_title.en,
//   job_title_fr: target?.job_title.fr,
//   job_description_en: target?.job_description.en,
//   job_description_fr: target?.job_description.fr,
//   job_type: target?.job_type,
//   job_salary: target?.job_salary,
//   // job_location: target?.job_location,
//   job_location_country: target?.job_location.country || user?.user_location.country,
//   job_location_state: target?.job_location.state || user?.user_location.state,
//   job_location_city: target?.job_location.city || user?.user_location.city,
//   job_status: !target ? "OPEN" : target?.job_status === "OPEN" ? "OPEN" : "CLOSED",
//   job_is_published: !target ? "PUBLISHED" : target?.job_is_published === true ? "PUBLISHED" : "UNPUBLISHED",
//   job_expiration_date: target?.job_expiration_date || new Date().setUTCMonth(new Date().getUTCMonth() + 1), // today + 1 month
//   job_sector_industry: target?.job_sector_industry
// }

// let missingFieldsInit = {
//   job_title_en: false,
//   job_description_en: false,
//   job_salary: false,
//   job_location_country: false,
//   job_location_state: false,
//   job_location_city: false,
//   job_sector_industry: false
// }


// const [loading, setLoading] = useState(false)
// const [data, setData] = useState(blankDataInit) 
// const [selectedTags, setSelectedTags] = useState()
// const [selectedLevel1Tags, setSelectedLevel1Tags] = useState(targetAssociatedLevel1Tags)
// const [selectedLevel2Tags, setSelectedLevel2Tags] = useState(targetAssociatedLevel2Tags)
// const [tagsTable, setTagsTable] = useState(null)
// const [missingFields, setMissingFields] = useState(missingFieldsInit)
// const [previewOpen, setPreviewOpen] = useState(true)
// const [fieldInFocus, setFieldInFocus] = useState(null)


// useEffect(() => {
//   if (target) {
//     setData(targetDataInit)
//     // set selected primary and secondary tags of a target to what's already associated. This is later updated in callback from handleTagsCallback. 
//     setSelectedLevel1Tags(targetAssociatedLevel1Tags)
//     setSelectedLevel2Tags(targetAssociatedLevel2Tags)
//   }
//   else {
//     setData(blankDataInit)
//     setSelectedLevel1Tags([])
//     setSelectedLevel2Tags([])
//   }

//   const getTags = async () => {

//     try {
//       let apiUrl = `/api/tags/`;
//       let response = await fetch(apiUrl, {
//         method: `GET`,
//         headers: {
//           Accept: "*/*",
//           "Content-Type": "application/json",
//         },
//         credentials: "include", // If you are sending cookies with a cross-origin request, use 'include'
//       });

//       response = await response.json();
//       // console.log('getTags Response', response)

//       setTagsTable(response.data);
//     } catch (error) {
//       console.log("error", error);
//     }


//   };

//   getTags();

// }, [target]);


// const handleTagsCallback = cb => {
//   console.log('Callback@HandleTagsCallback', cb)
//   if (cb.lvlOne) {  // primary
//     setSelectedLevel1Tags(cb.lvlOne.newTags)
//   }
//   if (cb.lvlTwo) { // secondary
//     setSelectedLevel2Tags(cb.lvlTwo.newTags)
//   }
//   console.log(selectedLevel1Tags, selectedLevel2Tags)
// }

// const handleDatePickerCallback = cb => {

//   console.log('cbDatepicker', cb)
//   if (cb.recreationOrExpiration === 'RECREATION') {
//     setData({...data, job_recreated_date: cb.datePicker})
//   }
//   else if (cb.recreationOrExpiration === 'EXPIRATION') {
//     setData({...data, job_expiration_date: cb.datePicker})
//   }

// }

// const handleRadioButtonCallback = cb => {
//   console.log('callback@JobModal', cb)
//   if (cb.job_type) {setData({...data, job_type: cb.job_type})}
//   if (cb.job_is_published) {setData({...data, job_is_published: cb.job_is_published})} // this is a str, not a Bool, it's converted to Bool in backend (post / put request)
//   if (cb.job_status) {setData({...data, job_status: cb.job_status})}
//   console.log(data)
//   // callback({action: "presetFilterApplied", presetFilterQuery: cb})
// }

//   const handleSectorSelectCallback = cb => {
//      setData({ ...data, job_sector_industry: cb ? JSON.stringify(cb) : null })
//      console.log("XDATA", data)
//   }



//   const handleChange = (event) => {
//     // setData({
//     //   ...data,
//     //   [event.target?.name]: event.target?.value,
//     // });
//     // console.log(data);
//     if (event.target?.name ==='job_salary') {
     
//       setData((prevData) => ({
//         ...prevData,
//         [event.target?.name]: event.target.value.replace(/\D/g, '')
//       }));
//       return;
//     }

//     setData((prevData) => ({
//       ...prevData,
//       [event.target?.name]: event.target?.value,
//     }));
  
//     if(event.target?.value.length > 1){setMissingFields((prevMissingFields) => ({
//       ...prevMissingFields,
//       [event.target?.name]: false, // Mark the field as not missing
//     }));}
//   };


//   const handleSubmit = async () => {
//     setLoading(true)


//     // const tempMissingFields = validateRequiredFieldsManually(data, false, [...Object.keys(missingFieldsInit)])
//     const tempMissingFields = validateRequiredFieldsManually(data, false, ['job_title_en', 'job_description_en', 'job_salary', 'job_location_country', 'job_location_state', 'job_location_city', 'job_sector_industry'])
//     setMissingFields(tempMissingFields)
  
  
//     // Log missing fields after they've been updated
//     console.log("MISSING FIELDS: ", tempMissingFields);
  
//     // If there are any missing fields, do not proceed with form submission
//     if (Object.values(tempMissingFields).includes(true)) {
//       // Create a string listing the keys of missing fields
//       const missingFieldsList = Object.keys(tempMissingFields)
//       .filter(key => tempMissingFields[key] === true) // Filter for missing fields
//       .join(', '); // Join them into a string
//       state.setError({message: lang==='fr' ? `Champs obligatoires manquants: ${missingFieldsList}` : `Missing Required Fields: ${missingFieldsList}`})
//       setLoading(false)
//       return;
//     }
  




//         try {
        
//           let jobApiUrl = target ? `/api/jobs/?id=${target.id}&user_type=${user.user_type}` : `/api/jobs/?user_type=${user.user_type}`
//           let response = await fetch(jobApiUrl, {
//           method: `${target ? 'PUT' : 'POST'}`, // Use uppercase for HTTP methods
//           headers: {
//             'Accept': '*/*',
//             'Content-Type': 'application/json'
//           },
//           credentials: 'include', // If you are sending cookies with a cross-origin request, use 'include'
//           body: JSON.stringify({data: data, tags: {LEVEL_1: selectedLevel1Tags, LEVEL_2: selectedLevel2Tags}, user: user}), // Convert the credentials object to a JSON string
//           // body: data
//         });

//         response = await response.json()
//         console.log('handleSubmitResponse', response)

//       if (response.success === true ) {
//         state.setSuccess({message: lang === 'fr' ? "Le Poste a été publié." : 'Job listing created / updated.'})
//         setLoading(false)
//         callback({refreshData: true})
//         callback({resetTarget: true})
//         state.setJobModalOpen(false)
//       }
//       else { 
//         state.setError({message: lang === 'fr' ? "Il y a eu un problème lors de la publication." : 'There was a problem creating / updating this job listing.'})
//         setLoading(false)
//       }
//       callback({refreshData: true})

            
//         } catch (error) {
//           console.log('error', error)
//           setLoading(false)
//         }
    





//     // axios
//     //   .put(`/people/${id}/`, data, {
//     //     //change to data if no work
//     //     headers: {
//     //       // 'Accept':'application/json',
//     //       // 'Content-Type':'application/json',
//     //       Accept: "multipart/form-data",
//     //       "Content-Type": "multipart/form-data",
//     //     },
//     //   })
//     //   .then((response) => {
//     //     setData(data);
//     //     console.log(response.data);
//     //     state.setSuccess({message: 'Profile Updated.'})
//     //     callback({refreshData: true})
//     //   })
//     //   .catch((error) => {
//     //     console.error(error);
//     //     state.setError({message: error.response.data?.message})
//     //     // setErrorMessage(`Code: ${error.code}`)
//     //   });
//   };


//   const handleClose = async () => {
//     state.setJobModalOpen(false)
//     callback({resetTarget: true})
//   }


//   return (
//     <>

// {/* <div class="right-0 top-0 overflow-x-hidden overflow-y-auto fixed inset-0 z-40 outline-none focus:outline-none mt-0 duration-300 ease-in-out transition-transform transform translate-x-full"> */}
// <div
//   className={`right-0 top-0 overflow-auto fixed inset-0 z-40 outline-none focus:outline-none mt-0 duration-300 ease-in-out transition-transform transform ${
//     state.jobModalOpen === true ? 'translate-x-0' : 'translate-x-full'
//   }`}
// >

// <div className="lg:mb-0 px-4 w-full h-screen lg:sticky top-0 overflow-auto no-scrollbar lg:flex flex-col justify-center" key={target?.id}>
//               {/* <div className="fixed top-0 right-0 h-screen w-full z-80 bg-white shadow-lg transform translate-x-full"> */}

//                <div className={`mt-0 absolute duration-300 ease-in-out transition-transform transform ${previewOpen ? 'left-0 md:w-7/12' : 'right-0 md:w-7/12'} top-0 min-h-screen w-full`}>
//                 {/*content*/}
//                 <div className="border-0 min-h-screen shadow-none relative flex flex-col w-full bg-white outline-none focus:outline-none dark:bg-gray-900">
//                   {/*header*/}
//                   {/* <div className="flex items-start z-40 justify-between p-5 border-b border-solid border-slate-200 rounded-t"> */}

//                   <ModalHeader caption={modalHeaderCaption} closeOnClickMethod={() => handleClose()}/>

   
// {/* {console.log('data@jobModal', data)} */}

//                   <div className="relative p-6 flex-auto text-left">
//                     <div className="my-4 text-slate-500 text-lg leading-relaxed text-gray-900 dark:text-gray-100">

//                     {/* <div className="col-span-5 w-6/12 mx-auto text-left"> */}
//                     <div className="flex grid lg:grid-cols-12 gap-1 mt-2 mb-2">
//                       {user.user_type === 'ROOT' && <div className={`lg:col-span-3 w-full`}>
//                       <FormSubHeading data={lang === 'fr' ? "Date de Création du Poste" : 'Job Creation Date'}/>
//                       <DatePicker callback={handleDatePickerCallback} recreationOrExpiration={'RECREATION'} targetDate={data.created_date || target?.created_date}/>
//                         </div>}
//                         <div className={`${user.user_type==='ROOT' ? 'lg:col-span-3' : 'lg:col-span-6'} w-full`}>
//                       <FormSubHeading data={lang === 'fr' ? "Date d'Expiration du Poste" : 'Job Expiration Date'}/>
//                       <DatePicker callback={handleDatePickerCallback} recreationOrExpiration={'EXPIRATION'} targetDate={data.job_expiration_date}/>
//                         </div>   
//                         <div className="lg:col-span-6 w-full justify-left">
//                         <FormSubHeading data={lang === 'fr' ? "Type de Poste" : 'Job Type'}/>
//                         <RadioButton_1
//                           name="jobTypeRadioSwitch"
//                           value1="PERMANENT"
//                           value2="CONTRACT"
//                           caption1="Permanent"
//                           caption2={lang === 'fr' ? "Contrat" : "Contract"}
//                           defaultChecked={data.job_type || 'PERMANENT'}
//                           callback={handleRadioButtonCallback}
//                           callbackObjectKey={'job_type'}
//                         />
//                   </div>
//                   </div>


//                   <div className="flex grid lg:grid-cols-12 gap-1 mt-2 mb-2">
//                       <div className="lg:col-span-6 w-full">
//                       <FormSubHeading data={lang === 'fr' ? "Status du Poste" : 'Job Status'}/>
//                       <RadioButton_1
//                           name="jobStatusRadioSwitch"
//                           value1="OPEN"
//                           value2="CLOSED"
//                           caption1={lang === 'fr' ? "Ouvert" : "Open"}
//                           caption2={lang === 'fr' ? "Fermé" : "Closed"}
//                           defaultChecked={data.job_status || 'OPEN'}
//                           callback={handleRadioButtonCallback}
//                           callbackObjectKey={'job_status'}
//                         />
//                         </div>       
//                         <div className="lg:col-span-6 w-full justify-left">
//                         <FormSubHeading data={lang === 'fr' ? "Publication du Poste" : 'Job Publication'}/>
//                         <RadioButton_1
//                           name="jobIsPublishedRadioSwitch"
//                           value1={"PUBLISHED"}
//                           value2={"UNPUBLISHED"}
//                           caption1={lang === 'fr' ? "Publié" : "Published"}
//                           caption2={lang === 'fr' ? "Non Publié" : "Not Published"}
//                           defaultChecked={data.job_is_published || "PUBLISHED"}
//                           callback={handleRadioButtonCallback}
//                           callbackObjectKey={'job_is_published'}
//                         />
//                   </div>
//                   </div>

              

                  
//                 {/* </div> */}

//                       <div className="flex grid lg:grid-cols-6 gap-1 align-middle mb-2">
//                       <div className={`${user.user_type === 'ROOT' ? 'lg:col-span-2' : 'lg:col-span-3'} w-full`}>
//                       <InputText 
//                         required={false} 
//                         name='job_title_en' 
//                         data={{type: 'text', id:'job_title_en', value: data.job_title_en || '' , onChange: handleChange, label: lang === 'fr' ? 'Titre du Poste en Anglais' : 'Job Title English'}} 
//                         error={missingFields['job_title_en'] === true}
//                       />
//                         </div>       
//                         <div className={`${user.user_type === 'ROOT' ? 'lg:col-span-2' : 'lg:col-span-3'} w-full`}>
//                         <InputText 
//                         error={missingFields['job_title_fr'] === true}
//                         required={false} 
//                         name='job_title_fr' data={{type: 'text', id:'job_title_fr', value: data.job_title_fr || '', onChange: handleChange, label: lang==='fr' ? 'Titre du Poste en Français' : 'Job Title French'}}/>
//                       </div>
//                       {user.user_type === 'ROOT' &&
//                       <div className="lg:col-span-2 w-full">
//                         <OrganizationSelect
//                           creatable={true}
//                           placeholder="Select Associated Company..."
//                           // value={
//                           //   data.job_organization_name ? {label: data.job_organization_name, value: data.job_organization_id} || {label: target?.job_organization_name, value: target?.job_organization_id} : ''
//                           // }
//                           value={data.job_organization_name ? {label: data.job_organization_name, value: data.job_organization_id} : {label: target?.job_organization_name, value: target?.job_organization_id}}
//                           onChange={(selected) => {
//                             if (selected){
//                               console.log('selected', selected)
//                             setData({
//                               ...data,
//                               job_organization_name: selected.name,
//                               job_organization_id: selected.id,
//                               job_organization_uuid: selected.organization_uuid
//                             });}
//                             else {
//                               setData({
//                                 ...data, 
//                                 job_organization_name: null,
//                                 job_organization_id: null,
//                                 job_organization_uuid: null
//                               })
//                             }
//                           }}
//                         />
//                                  </div>
//                                  }
   
//                       </div>

//                       <div className="flex grid lg:grid-cols-9 gap-1 mb-2">
//                       {/* <div className="lg:col-span-3 w-full">
//                       <TagsAssociationSelect tagsTable={tagsTable} callback={handleTagsCallback} tagsLevel={1} target={target} placeholder={lang === 'fr' ? 'Tags Principaux' : 'Primary Tags'}/>
//                       </div> */}

//                       <div className="lg:col-span-1 w-full">
//                       <FormSubHeading data={lang === 'fr' ? "Sous-Secteur de l'Emploi" : "Job SubSector"}/> 
//                       <TagsAssociationSelect lang={lang} state={{error: state.error, setError: state.setError}} selectedParent={data.job_sector_industry?.value} isMulti={false} tagsTable={tagsTable} callback={handleTagsCallback} tagsLevel={1} target={target} placeholder={lang === 'fr' ? "Sous-Secteur" : "SubSector"}/>
//                       </div>
//                       <div className="lg:col-span-3 w-full">
//                       <TagsAssociationSelect tagsTable={tagsTable} callback={handleTagsCallback} tagsLevel={2} target={target} placeholder={lang === 'fr' ? 'Tags Secondaires' : 'Secondary Tags'}/>
//                       </div>
//                       <div className="lg:col-span-3 w-full">
//                       <SectorSelect  
                      
//                        missingRequired={missingFields['job_sector_industry'] === true ? true : false}
//                        isMulti={false}
//                         parent={'JOB'}
//                         onChange={(selection)=>{
//                           selection.value && setMissingFields({...missingFields, job_sector_industry: false})
//                         }}
//                         lang={lang || 'en'}
//                         callback={handleSectorSelectCallback}
//                         target={target}
//                         // onChange={(selection) => { setData({ ...data, job_sector_industry: selection ? selection : null });}}
//                         placeholder={lang === 'fr' ? 'Secteur / Industrie' : 'Sector / Industry'}
//                       />

//                       </div>
//                       </div>
//                       {/* <DatePicker callback={handleDatePickerCallback} targetDate={target?.job_expiration_date}/> */}




//                       <div className="col-span-4 space-y-2">
//    {/* <InputText data={{type: 'text', id:'job_title_en', name: 'job_title_en', value: data.job_title_en , onChange: handleChange, label: 'Job Title English'}}/>

 
//    <InputText data={{type: 'text', id:'job_title_fr', name: 'job_title_fr', value: data.job_title_fr, onChange: handleChange, label: 'Job Title French'}}/> */}

                          
//               {/* <LocationSelect
//               value = {data.job_location ? {value: data.job_location, label: data.job_location} : ''}
//                               placeholder={lang === 'fr' ? 'Localisation' : 'Location'}
//                               onChange={(selection) => {
//                                 setData({ ...data, job_location: selection ? selection.value : null });
//                                 console.log('selected', selection);
//                               }}
//                             /> */}


// <div className="flex grid lg:grid-cols-3 gap-1 align-middle mb-2">
//                       <div className="lg:col-span-1 w-full">

//               <LocationSelect
//               missingRequired={missingFields['job_location_country'] === true }
//               zoomLevel={'COUNTRIES'}
//               value = {data.job_location_country ? {value: 'data.job_location_country', label: humanizeString(data.job_location_country)} : user.user_location?.country ? {value: user.user_location.country, label: humanizeString(user.user_location.country)}: ''} 
//               placeholder={lang === 'fr' ? 'Pays' : 'Country'}
//               onChange={(selection) => {
//               setData({ ...data, job_location_country: selection ? selection.value : null });
//               selection.value && setMissingFields({...missingFields, job_location_country: false });
//               }}
//             />
// </div>

// <div className="lg:col-span-1 w-full">
                         
//             <LocationSelect
//             missingRequired={missingFields['job_location_state'] === true ? true : false }
//               zoomLevel={'STATES'}
//             isDisabled={!data.job_location_country && !user.user_location.country}
//             selectedCountry={data?.job_location_country || user?.user_location?.country}
//             value = {data.job_location_state ? {value: data.job_location_state, label: humanizeString(data.job_location_state)} : ''}
//             placeholder={lang === 'fr' ? 'Province / État' : "State or Province"}
//             onChange={(selection) => {
//               setData({ ...data, job_location_state: selection ? selection.value : null, job_location_city: null });
//               selection.value && setMissingFields({...missingFields, job_location_state: false });
//                             }}
//                           />
//             </div>

//             <div className="lg:col-span-1 w-full">
                         
//             <LocationSelect
//             missingRequired={missingFields['job_location_state'] === true }
//             isDisabled={!data.job_location_state && !user.user_location.state}
//             zoomLevel={'CITIES'}
//             selectedCountry={data?.job_location_country || user?.user_location?.country}
//             selectedState={data?.job_location_state || user?.user_location?.state}
//             value = {data.job_location_city ? {value: data.job_location_city, label: humanizeString(data.job_location_city)} : ''}
//             placeholder={lang === 'fr' ? 'Ville' : "City"}
//             onChange={(selection) => {
//               setData({ ...data, job_location_city: selection ? selection.value : null });
//               selection.value && setMissingFields({...missingFields, job_location_city: false });
//             }}
//                           />
//             </div>
// <div className="lg:col-span-1 w-full">


//                       </div>
                      
//                       </div>
                       

//               <InputText 
//               error={missingFields['job_salary'] === true}
//               name='job_salary' data={{type: 'text', id:'job_salary', value: data.job_salary || '', onChange: handleChange, label: lang === 'fr' ? 'Salaire Offert' : 'Offered Salary'}}/>
// {/* <TextEditor/> */}

// <br/><br/>
// <MarkdownEditor 
//   textAreaOnChange={(x)=>{setFieldInFocus(x.target?.name)}} 
//   textAreaName={'job_description_en'}
//   textAreaId={'job_description_en'}
//   callback={(x)=>{handleChange(x)}} 
//   showPreview={false} 
//   textAreaRef={textAreaRef1} 
//   textAreaValue={data.job_description_en} 
//   textAreaPlaceholder={lang === 'fr' ? "Descriptif en Anglais" : 'Job Description'}
// />
// <br/>

// {user.user_languages?.working?.includes('FRENCH') && <MarkdownEditor 
//   textAreaOnChange={(x)=>{setFieldInFocus(x.target?.name)}} 
//   textAreaName={'job_description_fr'}
//   textAreaId={'job_description_fr'}
//   callback={(x)=>{handleChange(x)}} 
//   showPreview={false} 
//   // textAreaOnChange={handleChange} 
//   textAreaRef={textAreaRef2} 
//   textAreaValue={data.job_description_fr} 
//   textAreaPlaceholder={lang === 'fr' ? "Descriptif en Français" : 'Description in French'}
// />}

//                       </div>

// <br/><br/>





//                     </div>
//                   </div>

//                   {/*footer*/}
//                   <ModalFooter 
//                   missingRequiredFields={missingFields} 
//                   loading={loading} 
//                   cancelButtonCaption={lang==='fr' ? 'Annuler' : 'Cancel'} submitButtonCaption1={lang==='fr' ? <>{target ? <><i className="fa-solid fa-floppy-disk mr-1"/>Sauvegarder</> : <><i className="fa-solid fa-rocket mr-1"></i>Afficher</>}</> : <>{target ? <><i className="fa-solid fa-floppy-disk mr-1"/>Save</> : <><i className="fa-solid fa-rocket mr-1"></i>Post</>}</>} 

//                   submitButtonCaption2={lang === 'fr' ? !previewOpen ? <><i className="fa-solid fa-eye mr-1"/>Ouvrir Aperçu</> : <><i className="fa-solid fa-eye-slash mr-1"/>Fermer Aperçu</> : previewOpen ? <><i className="fa-solid fa-eye-slash mr-1"/>Close Preview</> : <><i className="fa-solid fa-eye mr-1"/>Open Preview</>}
//                   saveOnClickMethod2={()=>{setPreviewOpen(!previewOpen)}}
//                   closeOnClickMethod={() => {handleClose()}} saveOnClickMethod1={()=>{handleSubmit()}} 
//                   state={{error: state.error, setError: state.setError, success:state.success, setSuccess: state.setSuccess}}
//                   />

//                 </div>
//               </div>
//             </div>

//             <div key={target?.id+1}>
//               {/* <div className="fixed top-0 right-0 h-screen w-full z-80 bg-white shadow-lg transform translate-x-full"> */}

//               <div className={`fixed right-0 top-0 min-h-screen w-5/12 duration-300 ease-in-out transition-transform transform invisible md:visible ${
//     previewOpen === true ? 'translate-x-0' : 'translate-x-full'
//   }`}>
//                 {/*content*/}
//                 <div className="border-0 min-h-screen shadow-none relative flex flex-col w-full outline-none focus:outline-none bg-slate-50 dark:bg-slate-800">
//                   {/*header*/}
//                   {/* <div className="flex items-start z-40 justify-between p-5 border-b border-solid border-slate-200 rounded-t"> */}
                  
//                   <ModalHeader caption={lang === 'fr' ? <><i className="fa-solid fa-binoculars mr-2"/>Aperçu</> : <><i className="fa-solid fa-binoculars mr-2"/>Preview</>} closeOnClickMethod={() => setPreviewOpen(false)}/>
//                   {/* <div className="fixed top-0 bg-inherit flex items-center z-50 px-2 py-1 h-screen">
//                     test
//                   </div> */}
//                   <br/>
//                   <div className="px-8">
                    
//                   {data && 
//                   <JobPreviewCard
//                             lang={lang}
//                             data={data}
//                             tags={selectedLevel1Tags.concat(selectedLevel2Tags)}
//                             // selectedId={
//                             //  selectedTalentId || talentsTable[0].id
//                             // }
//                           />
//                           }
//                   </div>

//                   {data[`job_description_${lang || 'en'}`] && <div className={`mx-8 px-6 py-8 mt-10 rounded-xl bg-white py-3 dark:bg-gray-900 shadow-lg flex flex-col h-full text-slate-500 dark:text-slate-300  font-inter overflow-y-auto whitespace-pre-wrap prose-sm max-w-none `}>

    
//                               {/* job description that's currently in focus */}
//                           <ReactMarkdownMod args={data[fieldInFocus || `job_description_${lang || 'en'}`]}/>


              
//                     </div>}
   
   
//                   {/* <div className="relative p-6 flex-auto text-left">
//                     <div className="my-4 text-slate-500 text-lg leading-relaxed text-gray-900 dark:text-gray-100">
//                     </div>
//                   </div> */}
                      
                      
//                       </div>
//                       </div></div>
//           </div>

//           {state.jobModalOpen && <ModalOverlay/>}
//         </>

//   );
// };

// export default JobModal;






